import { mq } from '@kvdbil/components';
import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
  background: ${({ theme }) => theme.colors.background.gray};

  .youtubeHero__wrapper {
    margin: 0 auto;

    ${mq('tablet')} {
      max-width: 711px;
    }

    ${mq('laptop')} {
      max-width: 772px;
    }
  }

  .youtubeHero__player {
    position: relative;
    padding-bottom: 56.25%;
    height: 0;
  }

  .youtubeHero__iframe {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
  }
`;
interface Props {
  url: string;
}

const YoutubeHero = ({ url }: Props) => (
  <Container className="youtubeHero" data-testid="youtube-hero">
    <div className="youtubeHero__wrapper">
      <div className="youtubeHero__player">
        <iframe
          title="youtube hero"
          data-testid="youtubeHero"
          className="youtubeHero__iframe"
          src={url}
          width="100%"
          height="100%"
          frameBorder="0"
        />
      </div>
    </div>
  </Container>
);

export default YoutubeHero;
